module.exports = __webpack_public_path__ + "assets/fabbb3d643668a9e62bea4e4a20f1ac2.mp3";